<template>
  <div class="vnis">
    <button @click.prevent="decreaseNumber" class="vnis__button">-</button>
    <input class="vnis__input"
        type="number"
        v-bind:value="numericValue"
        @keypress="validateInput"
        @input="numericValue = $event.target.value"
        :min="min"
        :max="max"
        debounce="500"
    />
    <button @click.prevent="increaseNumber" class="vnis__button">+</button>
  </div>
</template>

<script>
import { NumberSpinner } from './number-spinner';
export default NumberSpinner;
</script>

<style lang="less">
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }
</style>






// WEBPACK FOOTER //
// src/components/number-spinner.vue